<script setup lang="ts">
import { toRef, watch } from "vue";
import { useGetUnsortedFindings } from "@/stores/queries";
import type { Finding } from "@/types/findings.types";
import FindingsTable from "./FindingsTable.vue";

const props = defineProps<{
  diagnosticId: number;
  reportId: number;
}>();

const emit = defineEmits<{
  (e: "edit", finding: Finding): void;
  (e: "count", count: number): void;
  (e: "create"): void;
}>();

const reportIdRef = toRef(props, "reportId");
const { data: findings } = useGetUnsortedFindings(reportIdRef);

// Emit count when findings change
watch(
  findings,
  (newFindings) => {
    emit("count", newFindings?.length ?? 0);
  },
  { immediate: true },
);
</script>

<template>
  <div
    v-if="findings?.length"
    class="bordered shadow-1 rounded bg-white overflow-hidden"
  >
    <FindingsTable
      :findings="findings"
      :diagnostic-id="diagnosticId"
      :report-id="reportId"
      :section-id="null"
      :show-numbering="false"
      show-add-button
      @edit="(finding) => emit('edit', finding)"
      @create="emit('create')"
    />
  </div>
</template>
